export default __webpack_public_path__ + "static/char-thumb-41-4d6478e8e058b1731f53ef056f629b30.png";